import { request } from '../utils/request'

const baseUrl = 'https://se-main-gqi6flraoa-uc.a.run.app/main/';

export function getUserData(token) {
    // console.log('Models: ', token)
    return request({
        method: 'get',
        url: baseUrl + `user/`,
        headers: {
            'Authorization': token
        }
    })
}

export function getUserList(token) {
    // console.log('Models: ', token)
    return request({
        method: 'get',
        url: baseUrl + `admin/users`,
        headers: {
            'Authorization': token
        }
    })
}

export function addUser(token, email, organization, is_admin, user_id) {
    // console.log('Models: ', token)
    return request({
        method: 'post',
        url: baseUrl + `admin/users`,
        data: {
            email: email,
            organization: organization,
            is_admin: is_admin,
            user_id: user_id
        },
        headers: {
            'Authorization': token
        }
    })
}

export function removeUser(token, userId) {
    console.log('Models: ', userId)
    return request({
        method: 'delete',
        url: baseUrl + `admin/users/${userId}`,
        data: {},
        headers: {
            'Authorization': token
        }
    })
}

export function getModelsByUser(token, userId) {
    // console.log('Models: ', token, userId)
    return request({
        method: 'get',
        url: baseUrl + `admin/users/${userId}/models`,
        headers: {
            'Authorization': token
        }
    })
}

export function addModel(token, client_id, model_id, model_name, description, model_type, model_url) {
    return request({
        method: 'post',
        url: baseUrl + `admin/models`,
        data: {
            client_id: client_id,
            model_id: model_id,
            model_url: model_url,
            model_name: model_name,
            description: description,
            model_type: model_type,
            // routing_table: routing_table,
        },
        headers: {
            'Authorization': token
        }
    })
}

export function editModel(token, client_id, model_id, model_name, description, model_type, extra_info, plot_conf, background_image, routing_table, model_url) {
    console.log(routing_table)
    return request({
        method: 'post',
        url: baseUrl + `admin/models/update`,
        data: {
            client_id: client_id,
            model_id: model_id,
            model_name: model_name,
            model_url: model_url,
            description: description,
            model_type: model_type,
            extra_info: extra_info,
            plot_conf: plot_conf,
            background_image: background_image,
            routing_table: routing_table
        },
        headers: {
            'Authorization': token
        }
    })
}

export function deleteModel(token, client_id, model_id) {
    return request({
        method: 'delete',
        url: baseUrl + `admin/models`,
        data: {
            client_id: client_id,
            model_id: model_id
        },
        headers: {
            'Authorization': token
        }
    })
}

export function versionManage(token, client_id, model_id, operation, pop_version_name, new_version) {
    console.log(client_id, model_id, operation, pop_version_name, new_version)
    return request({
        method: 'post',
        url: baseUrl + `admin/models/versions`,
        data: {
            client_id: client_id,
            model_id: model_id,
            operation: operation,
            pop_version_name: pop_version_name,
            new_version: new_version
        },
        headers: {
            'Authorization': token
        }
    })
}

export function getNewApiToken(token) {
    // console.log('Api Key: ', token)
    return request({
        method: 'post',
        url: baseUrl + `user/api-token/new`,
        data: {},
        headers: {
            'Authorization': token
        }
    })
}

export function deleteApiToken(token) {
    // console.log('Delete Api Key: ', token)
    return request({
        method: 'delete',
        url: baseUrl + `user/api-token`,
        data: null,
        headers: {
            'Authorization': token
        }
    })
}

export function setDarkMode(token, isDark) {
    // console.log('Api Key: ', token)
    return request({
        method: 'post',
        url: baseUrl + `user/visuals`,
        data: {
            dark_mode: isDark
        },
        headers: {
            'Authorization': token
        }
    })
}

export function getValidationUserId(token, userId) {
    console.log('Models: ', token, userId)
    return request({
        method: 'get',
        url: baseUrl + `user/validate-id`,
        headers: {
            'Authorization': token
        },
        params: {
            user_id: userId
        }
    })
}

export function changeUserId(token, userId) {
    // console.log('Models: ', token, userId)
    return request({
        method: 'post',
        url: baseUrl + `user/id`,
        headers: {
            'Authorization': token
        },
        params: {
            user_id: userId
        }
    })
}

export function postForgotPassword(email) {
    // console.log('Change Password: ', token, email)
    return request({
        method: 'post',
        url: baseUrl + `user/forgot-password`,
        data: {
            email: email
        },
        // headers: {
        //     'Authorization': token
        // }
    })
}

export function postNewPassword(action_code, new_password) {
    console.log('Change Password: ', action_code, new_password)
    return request({
        method: 'post',
        url: baseUrl + `user/reset-password`,
        data: {
            action_code: action_code,
            new_password: new_password
        },
        // headers: {
        //     'Authorization': token
        // }
    })
}